import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PatientsTable from './patientsTable';
import constant from '../../constant';

const PatientsContent = () => {
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { hospitalId } = useParams();

  useEffect(() => {
    const fetchPatients = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${constant.REACT_APP_API_URL}/hospital/${hospitalId}/patient/`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const result = await response.json();
        if (response.ok) {
          setPatients(result.map(patient => ({
            patient_id: patient.patient_id,
            patient_hospital_id: patient.patient_hospital_id,
            bed_number: patient.bed_number,
            name: patient.name,
            date_of_birth: patient.date_of_birth,
            gender: patient.gender,
            admitted_on: patient.admitted_on,
            hospital_id: patient.hospital_id,
            created_on: patient.created_on,
            created_by: patient.created_by,
            is_released: patient.is_released,
            is_active: patient.is_active,
          })));
        } else {
          setError(result.message || 'Failed to fetch patients');
        }
      } catch (error) {
        setError('Error fetching patients');
      } finally {
        setLoading(false);
      }
    };

    fetchPatients();
  }, [hospitalId]);

  const handleDelete = async (id) => {
    const token = localStorage.getItem('token');
    if (!token) {
      setError('No authentication token found');
      return;
    }

    try {
      const response = await fetch(`${constant.REACT_APP_API_URL}/hospital/${hospitalId}/patient/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();
      if (response.ok) {
        setPatients(patients.filter((patient) => patient.patient_id !== id));
      } else {
        setError(result.message || 'Failed to delete patient');
      }
    } catch (error) {
      setError('Error deleting patient');
    }
  };

  const handleEdit = (updatedPatient) => {
    setPatients(patients.map((patient) =>
      patient.patient_id === updatedPatient.patient_id ? updatedPatient : patient
    ));
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-10 text-red-500">
        {error}
        <button
          onClick={() => setError(null)}
          className="ml-4 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
        >
          Clear Error
        </button>
      </div>
    );
  }

  return (
    <div className="px-6 pt-16 md:pt-0">
      <div className="">
        <PatientsTable
          patients={patients}
          onDelete={handleDelete}
          onEdit={handleEdit}
          hospitalId={hospitalId}
        />
      </div>
    </div>
  );
};

export default PatientsContent;